import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-add-model',
  templateUrl: './payment-add-model.component.html',
})
export class PaymentAddModelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
